import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import Logo from "@/components/zeblan/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("zeblan_token", data.token);
      localStorage.setItem("zeblan_admin_email", data.email);
      toast.success("Welcome back.");
      nav("/admin/leads");
    } catch (err) {
      const msg = formatApiErrorDetail(err.response?.data?.detail) || "Login failed.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-cloud grid place-items-center px-6">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-md bg-white border border-mist rounded-2xl p-8 shadow-[0_18px_40px_-22px_rgba(10,19,40,0.18)]"
        data-testid="admin-login-form"
      >
        <Logo variant="light" className="h-16 w-auto mx-auto" />
        <h1 className="mt-6 text-center text-navy text-[24px] font-extrabold tracking-tightish">Admin sign-in</h1>
        <p className="mt-2 text-center text-steel text-[13px]">View leads collected from the site.</p>

        <label className="block mt-7">
          <span className="block text-[12px] font-semibold text-navy mb-1.5">Email</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full bg-cloud border border-mist focus:border-blue focus:bg-white rounded-lg px-3.5 py-2.5 text-[14px] text-navy outline-none"
            data-testid="admin-login-email"
          />
        </label>

        <label className="block mt-4">
          <span className="block text-[12px] font-semibold text-navy mb-1.5">Password</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full bg-cloud border border-mist focus:border-blue focus:bg-white rounded-lg px-3.5 py-2.5 text-[14px] text-navy outline-none"
            data-testid="admin-login-password"
          />
        </label>

        <button
          type="submit"
          disabled={loading}
          className="mt-6 w-full bg-blue hover:bg-blue-deep disabled:opacity-60 text-white font-semibold px-6 py-3 rounded-md transition-colors"
          data-testid="admin-login-submit"
        >
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </main>
  );
}
